import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnnouncekitComponent } from './announcekit.component';



@NgModule({
  declarations: [
    AnnouncekitComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AnnouncekitComponent
  ]
})
export class AnnouncekitModule { }
